import { ListContainer, ExecuteParams, PromptFunction } from '../../types';
import { createCustomFunction } from './createFunction';


/**
 * 上下文相关函数
 * @returns 上下文相关函数对象
 */
const logicFunctions: Record<string, PromptFunction> = {
  and: createCustomFunction(
    'and',
    '过滤给定参数，只保留那些匹配为真的参数。',
    (context, ...params: ExecuteParams[]): ListContainer<any> | void => {
      const result: ExecuteParams[] = params.filter(param => Boolean(param))
      if (!result.length) return
      return {
        type: 'listContainer',
        defaultFormat: 'inherited',
        elements: result,
      }
    }
  ),
  contains: createCustomFunction(
    'contains',
    '若给定干草堆（数据集合）中包含指定针（搜索项），则对其进行筛选（不区分大小写）。',
    (context, ...params: ExecuteParams[]): ListContainer<any> | void => {

    }
  ),
  either: createCustomFunction(
    'either',
    '返回第一个非空参数。',
    (context, ...params: ExecuteParams[]): any => {
      return params.find(param => Boolean(param))
    }
  ),
  endsWith: createCustomFunction(
    'endsWith',
    '如果给定的干草堆（数据集合）以指定的针（搜索项）结尾，则返回真（不区分大小写）。',
    (context, ...params: ExecuteParams[]): boolean => {
      const result: ExecuteParams[] = params.filter(param => Boolean(param))
      return result.every(param => String(param).endsWith(String(params[0])))
    }
  ),
  ifs: createCustomFunction(
    'ifs',
    '返回第一个为真的条件所对应的值；若无条件为真，则返回最后一个值（例如："ifs(条件A, 值A, 条件B, 值B, 备用值)"）。',
    (context, ...params: ExecuteParams[]) => {

    }
  ),
  isStartOfText: createCustomFunction(
    'isStartOfText',
    '检查当前位置是否位于文档/场景的开头（即之前没有文本）。',
    (context): boolean => {
      const { currentPosition } = context.globalContext
      return !currentPosition?.sceneSoFar
    }
  ),
  is: createCustomFunction(
    'is',
    '比较操作符，检查左右两个值是否相等。',
    (context, left: ExecuteParams, right: ExecuteParams): boolean => {
      // 使用严格相等比较，但处理特殊情况
      if (left === right) return true;
      // 处理 null 和 undefined
      if (left == null && right == null) return true;
      // 处理对象和数组的深度比较（简单版本）
      if (typeof left === 'object' && typeof right === 'object' && left !== null && right !== null) {
        try {
          return JSON.stringify(left) === JSON.stringify(right);
        } catch {
          return false;
        }
      }
      return false;
    }
  ),
}

export default logicFunctions;